import * as React from 'react'
import { Input } from '@mobiscroll/react-latest'
import UIMessages from 'src/utils/ui-messages'
import FindIcon from '../icons/ui/Find'

interface IOrganizationsSearchProps {
  onChange: (e: any) => void
}

class OrganizationsSearch extends React.Component<IOrganizationsSearchProps> {
  public render() {
    return (
      <div className='flex items-center relative'>
        <Input
          className='mbsc-input-with-start-icon mbsc-input-with-start-icon-label'
          inputStyle='box'
          label={UIMessages.common.search}
          labelStyle='floating'
          theme='ios'
          type='text'
          onChange={this.props.onChange}
        />
        <FindIcon className='absolute ml1 svg-stroke-grey2' />
      </div>
    )
  }
}

export default OrganizationsSearch



// WEBPACK FOOTER //
// ./src/components/organizations/OrganizationsSearch.tsx